<template>
  <div class="app-container">
    <div class="border">
      <h5 class="title">装修总览</h5>
      <div class="overview">
        <el-progress
          type="circle"
          :width="200"
          :stroke-width="15"
          :format="totalityFormat"
          class="totalityFormat"
          :percentage="parseFloat(100)"
          color="#7ecf51"
          define-back-color="#61a5e8"
        ></el-progress>
        <el-progress
          type="circle"
          :width="200"
          :stroke-width="15"
          :format="violationFormat"
          class="violationFormat"
          :percentage="
            parseInt((count.total__false_num / count.total_all) * 100)
          "
          v-if="
            !isNaN(
              parseInt(
                (this.count.total__false_num / this.count.total_all) * 100
              )
            )
          "
          color="#7ecf51"
          define-back-color="#61a5e8"
        ></el-progress>
        <el-progress
          type="circle"
          :width="200"
          :stroke-width="15"
          :format="checkFormat"
          class="checkFormat"
          :percentage="parseInt((count.has_end_num / count.total_all) * 100)"
          v-if="!isNaN(parseInt((count.has_end_num / count.total_all) * 100))"
          color="#7ecf51"
          define-back-color="#61a5e8"
        ></el-progress>
      </div>
    </div>
    <div class="border" style="margin-top: 20px">
      <h5 class="title">装修巡检统计</h5>
      <div class="" style="display: flex; justify-content: space-between">
        <div class="exhibition">
          <img src="../../static/headImg.png" alt="" />
          <div style="text-align: center; margin-left: 20px">
            <div style="font-weight: 600; font-size: 20px">
              {{ count.has_ing_num }}
            </div>
            <div style="margin-top: 10px">当前装修户数</div>
            <div>单位(户)</div>
          </div>
        </div>
        <div
          id="histogram"
          ref="histogram"
          style="width:80%; height: 400px;overflow: auto;"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { getStatistics } from "@/api/renovation";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      count: {},
      list: [],
      chartDom: "",
      myChart: "",
      option: "",
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    //调用方法
    // this.$nextTick(function () {
    //   this.drawChart_bar();
    // });
  },
  methods: {
    drawChart_bar() {
      console.log(document.getElementById("histogram"));
      // var chartDom = document.getElementById("main");
      // var myChart = this.$echarts.init(chartDom);
      let myChart = this.$echarts.init(this.$refs.histogram);
      var option;
      var yxj = [];
      var wxj = [];
      var timeList = [];

      console.log(this.list);
      this.list.forEach((item, index) => {
        // console.log(item)
        yxj.push(item.y1);
        wxj.push(item.y2);
        timeList.push(item.x1);
      });
      console.log(yxj, wxj, timeList);
      var dataZoomEnd = timeList.length > 20 ? 30 :100
      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          minInterval: 1,
        },
        xAxis: {
          type: "category",
          data: timeList
        },
        dataZoom: [
        {
            type: 'slider',
            show:dataZoomEnd == 100?false :true,
            realtime:true,
            start: 0,
            end: dataZoomEnd
        },
        {
            type: 'slider',
            realtime:true,
            start: 0,
            end: dataZoomEnd
        }
    ],
        series: [
          {
            name: "已巡检",
            type: "bar",
            data: yxj,
            itemStyle: {
              color: "#7ecf51",
            },
          },
          {
            name: "未巡检",
            type: "bar",
            data: wxj,
            itemStyle: {
              color: "#61a5e8",
            },
          },
        ],
      };

      myChart.setOption(option);
    },

    // 已验收总数
    checkFormat() {
      return this.count.has_end_num;
    },
    // 违规总数
    violationFormat() {
      return this.count.total__false_num < 1
        ? "0"
        : this.count.total__false_num;
    },
    // 装修总数
    totalityFormat() {
      return this.count.total_all;
    },
    async getData() {
      await getStatistics().then((res) => {
        this.count = res.data.count;
        this.list = res.data.list;
        console.log(res);
      });
      this.$nextTick(function () {
        this.drawChart_bar();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.border {
  border: 1px solid #ccc;
  padding: 20px;
}
::v-deep .totalityFormat .el-progress__text::after {
  content: "装修总户数单位(户)";
  font-size: 12px;
  font-weight: 400;
  color: #9c9ab3;
  display: block;
  margin-top: 20px;
}
::v-deep .violationFormat .el-progress__text::after {
  content: "违规户数单位(户)";
  font-size: 12px;
  font-weight: 400;
  color: #9c9ab3;
  display: block;
  margin-top: 20px;
}

::v-deep .checkFormat .el-progress__text::after {
  content: "已验收户数单位(户)";
  font-size: 12px;
  font-weight: 400;
  color: #9c9ab3;
  display: block;
  margin-top: 20px;
}

::v-deep .gpuRateFormat .el-progress__text::after {
  content: "装修总户数单位(户)";
  font-size: 12px;
  font-weight: 400;
  color: #9c9ab3;
  display: block;
  margin-top: 20px;
}
.overview {
  display: flex;
  justify-content: space-around;
}
.title {
  margin: 0px 0 20px 0;
  font-size: 18px;
}
.exhibition {
  display: flex;
  border: 1px solid #ccc;
  padding: 10px;
  height: 100px;
  font-size: 14px;
  display: flex;
  align-items: center;
}
</style>
